import styled from 'styled-components';
import { motion } from 'framer-motion';

export const ModalWrapper = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background-color: rgb(255, 255, 255);
  border-radius: 8px;
  outline: none;
  width: 95vw;
  max-width: 900px;
  max-height: 85vh;
  display: flex;
  flex-direction: column;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);

  @media (min-width: 600px) {
    width: 90vw;
  }

  @media (min-width: 960px) {
    width: 900px;
  }
`;

export const ModalHeader = styled.div`
  padding: 12px 24px;
  border-bottom: 1px solid #e2e8f0;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const ModalTitleContainer = styled.div`
  flex: 1;
`;

export const ModalTitle = styled.h2`
  font-size: 1.25rem;
  font-weight: 600;
  color: #1e293b;
  margin: 0;
`;

export const ModalDescription = styled.p`
  font-size: 0.875rem;
  color: #64748b;
  margin: 4px 0 0 0;
`;

export const CloseButton = styled.button`
  background: none;
  border: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 4px;
  color: #64748b;
  border-radius: 4px;
  transition: all 0.2s ease;

  &:hover {
    background-color: #f1f5f9;
    color: #1e293b;
  }
`;

export const ModalContent = styled.div`
  padding: 8px 24px;
  overflow-y: auto;
  overflow-x: hidden;
  position: relative;

  @media (max-width: 600px) {
    padding: 6px 16px;
  }
`;

export const ModalFooter = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  padding: 12px 24px;
  border-top: 1px solid #e2e8f0;

  @media (max-width: 600px) {
    padding: 8px 16px;
  }
`;

export const FormGroup = styled.div`
  margin-bottom: 12px;
`;

export const FormLabel = styled.label`
  display: block;
  font-size: 0.875rem;
  font-weight: 500;
  color: #1e293b;
  margin-bottom: 6px;
`;

export const FormSection = styled.div`
  padding: 12px;
  border: 1px solid #e2e8f0;
  border-radius: 6px;
  margin-bottom: 12px;
  background-color: #f8fafc;
`;

export const FormSectionTitle = styled.h4`
  font-size: 0.875rem;
  font-weight: 500;
  color: #1e293b;
  margin: 0 0 12px 0;
`;

export const FormGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 16px;

  @media (max-width: 600px) {
    grid-template-columns: 1fr;
  }
`;

export const FormGridThree = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 16px;

  @media (max-width: 768px) {
    grid-template-columns: repeat(2, 1fr);
  }

  @media (max-width: 600px) {
    grid-template-columns: 1fr;
  }
`;

export const FormLayout = styled.div`
  display: grid;
  grid-template-columns: 2fr 1fr;
  gap: 16px;
  align-items: stretch;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
    gap: 12px;
  }
`;

export const SwitchContainer = styled.div`
  display: flex;
  gap: 24px;
  margin-top: 12px;

  @media (max-width: 600px) {
    flex-direction: column;
    gap: 12px;
  }
`;

export const SwitchItem = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const SwitchLabel = styled.span`
  font-size: 0.875rem;
  font-weight: 500;
  color: #1e293b;
`;

export const InfoAlert = styled.div`
  display: flex;
  align-items: center;
  background-color: rgb(230, 244, 250);
  color: rgb(30, 64, 175);
  border: 1px solid rgb(147, 197, 253);
  border-radius: 4px;
  padding: 8px 12px;
  font-size: 0.875rem;
  line-height: 1.4;
  margin-top: 12px;
  gap: 8px;
`;

export const WarningAlert = styled.div`
  display: flex;
  align-items: center;
  background-color: rgb(250, 242, 230);
  color: rgb(234, 132, 77);
  border: 1px solid rgb(254, 186, 84);
  border-radius: 4px;
  padding: 8px 12px;
  font-size: 0.875rem;
  line-height: 1.4;
  margin-top: 12px;
  gap: 8px;
`;

export const ErrorAlert = styled.div`
  display: flex;
  align-items: center;
  background-color: rgb(254, 242, 242);
  color: rgb(220, 38, 38);
  border: 1px solid rgb(252, 165, 165);
  border-radius: 4px;
  padding: 12px;
  font-size: 0.875rem;
  line-height: 1.4;
  margin-bottom: 16px;
  gap: 8px;
`;

export const LoadingContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
  gap: 12px;
`;

export const LoadingText = styled.span`
  font-size: 0.875rem;
  color: #64748b;
  font-style: italic;
`;

export const EmptyStateContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 48px 24px;
  text-align: center;
  gap: 16px;
`;

export const EmptyStateIcon = styled.div`
  color: #94a3b8;
  font-size: 48px;
`;

export const EmptyStateTitle = styled.h3`
  font-size: 1.125rem;
  font-weight: 500;
  color: #64748b;
  margin: 0;
`;

export const EmptyStateDescription = styled.p`
  font-size: 0.875rem;
  color: #94a3b8;
  margin: 0;
  max-width: 300px;
`;

export const TableContainer = styled.div`
  margin-top: 16px;
  border: 1px solid #e2e8f0;
  border-radius: 6px;
  overflow: hidden;
`;

export const TableHeader = styled.div`
  background-color: #f8fafc;
  padding: 12px 16px;
  border-bottom: 1px solid #e2e8f0;
  font-weight: 500;
  color: #1e293b;
  font-size: 0.875rem;
`;

export const TableRow = styled.div<{ isHeader?: boolean }>`
  display: flex;
  align-items: center;
  padding: 12px 16px;
  border-bottom: 1px solid #e2e8f0;
  background-color: ${(props) =>
    props.isHeader ? '#f8fafc' : 'white'};
  font-weight: ${(props) => (props.isHeader ? '500' : '400')};
  color: ${(props) => (props.isHeader ? '#1e293b' : '#374151')};
  font-size: 0.875rem;

  &:last-child {
    border-bottom: none;
  }

  &:hover {
    background-color: ${(props) =>
      props.isHeader ? '#f8fafc' : '#f9fafb'};
  }
`;

export const TableCell = styled.div<{ flex?: number }>`
  flex: ${(props) => props.flex || 1};
  padding-right: 16px;

  &:last-child {
    padding-right: 0;
  }
`;

export const ActionButton = styled.button<{
  variant?: 'primary' | 'secondary' | 'danger';
}>`
  padding: 6px 12px;
  border: none;
  border-radius: 4px;
  font-size: 0.75rem;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
  background-color: ${(props) => {
    switch (props.variant) {
      case 'primary':
        return '#293778';
      case 'secondary':
        return '#f1f5f9';
      case 'danger':
        return '#dc2626';
      default:
        return '#f1f5f9';
    }
  }};
  color: ${(props) => {
    switch (props.variant) {
      case 'primary':
        return 'white';
      case 'secondary':
        return '#374151';
      case 'danger':
        return 'white';
      default:
        return '#374151';
    }
  }};

  &:hover {
    background-color: ${(props) => {
      switch (props.variant) {
        case 'primary':
          return '#1e2654';
        case 'secondary':
          return '#e2e8f0';
        case 'danger':
          return '#b91c1c';
        default:
          return '#e2e8f0';
      }
    }};
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;

export const Badge = styled.span<{
  variant?: 'success' | 'warning' | 'error' | 'info' | 'primary';
}>`
  display: inline-flex;
  align-items: center;
  padding: 4px 8px;
  border-radius: 4px;
  font-size: 0.75rem;
  font-weight: 500;
  background-color: ${(props) => {
    switch (props.variant) {
      case 'success':
        return '#dcfce7';
      case 'warning':
        return '#fef3c7';
      case 'error':
        return '#fee2e2';
      case 'info':
        return '#dbeafe';
      case 'primary':
        return '#e0e7ff';
      default:
        return '#f3f4f6';
    }
  }};
  color: ${(props) => {
    switch (props.variant) {
      case 'success':
        return '#166534';
      case 'warning':
        return '#92400e';
      case 'error':
        return '#991b1b';
      case 'info':
        return '#1e40af';
      case 'primary':
        return '#3730a3';
      default:
        return '#374151';
    }
  }};
`;

export const SearchContainer = styled.div`
  position: relative;
  margin-bottom: 16px;
`;

export const SearchInput = styled.input`
  width: 100%;
  padding: 8px 12px 8px 36px;
  border: 1px solid #cbd5e1;
  border-radius: 4px;
  font-size: 0.875rem;
  color: #1e293b;

  &:focus {
    outline: none;
    border-color: #293778;
    box-shadow: 0 0 0 2px rgba(41, 55, 120, 0.1);
  }

  &::placeholder {
    color: #94a3b8;
  }
`;

export const SearchIconWrapper = styled.div`
  position: absolute;
  left: 12px;
  top: 50%;
  transform: translateY(-50%);
  color: #94a3b8;
  display: flex;
  align-items: center;
`;

export const containerVariants = {
  hidden: { opacity: 0, y: 20 },
  visible: { opacity: 1, y: 0, transition: { duration: 0.2 } },
  exit: { opacity: 0, y: 20, transition: { duration: 0.2 } },
};
